import * as anchor from '@project-serum/anchor';

import './Products.css';
import { PublicKey } from '@solana/web3.js';
import Home from './Home';
import Grid from '@material-ui/core/Grid';

export interface ProductsProps {
  candyMachineIds: string[];
  connection: anchor.web3.Connection;
  txTimeout: number;
  rpcHost: string;
}

const Products = (props: ProductsProps) => {
  const cmAddresses = props.candyMachineIds.map(id => new PublicKey(id));
  return (
    <Grid
      container
      spacing={4}>
      {Array.from(cmAddresses).map((cmAddress, index) => (
        <Grid item xs={12} sm={6} md={4} lg={4} key={index}>
          <Home
            candyMachineId={cmAddress}
            connection={props.connection}
            txTimeout={props.txTimeout}
            rpcHost={props.rpcHost} />
        </Grid>
      ))}
    </Grid>
  )
};

export default Products;
